import { TicketTypes } from "./supportType";

export const initialState: TicketTypes = {
  fetching: false,
  error: null,
  success: null,
  message: null,
  statusCode: null,
  ticketDetails: null,
  ticketComments: null,
  ticketList: null,
  allTicketList: null,
  categoryWiseCountList: null,
  assignedToUserTicketsList: null,
};
